<template>
	<router-view></router-view>
</template>

<script>
	export default {
		name: 'app',
		components: {

		},
		data() {
			return {}
		},
		mounted() {}
	};
</script>

<style lang="scss">
	.recom-wrap {
		.ucard.ucard-border .el-card__body {
			padding: 10px 20px 25px;
		}

		.el-tabs__item {
			font-size: 16px;
			font-weight: bold;
		}
	}
	.qtable {
		width: 99%;
	}
	.wxcode-popup {
		.tit {
			font-size: 16px;
			color: #333;
			font-weight: bold;
			margin-bottom: 10px;
		}

		.text {
			font-size: 15px;
			color: #666;
			margin-bottom: 10px;
			line-height: 1.6;
		}

		.qrcode-code {
			text-align: center;
			padding: 20px 0;
		}

		.img {
			width: 240px;
			height: 240px;
		}
	}

	.inp-warp {
		display: flex;
		align-items: center;
		padding: 15px 0 0;

		.cont {
			width: 200px;
			padding: 0 10px;
		}

		.value {
			color: $color;
		}
	}

	.dialog-wrap {
		// .el-radio {
		// 	margin: 0;
		// }

		.el-radio__label {
			padding: 0;
		}

		// .el-radio__label {
		// 	display: none;
		// }
	}


	.select-examadd {
		.exam-item {
			cursor: pointer;
			background: #f8fafd;
			width: 100%;
			height: 50px;
			padding: 0 20px;
			display: flex;
			margin-bottom: 12px;
			border-radius: 8px;
			align-items: center;

			.tit {
				flex: 1;
				font-size: 16px;
				color: #2f3541;
			}

			.icons {
				font-size: 26px;
				height: 26px;
				color: #1492ff;
			}

			.icon-dot {
				width: 24px;
				height: 24px;
				border-radius: 50%;
				display: inline-block;
				background: #dce4ef;
			}
			
		}
	}

	.dialog-wrap {
		.el-tree-node__content {
			height: 36px;
			// margin-bottom: 8px;
			// padding-bottom: 8px;
		}
	}
	
	
	
	.el-tree > .el-tree-node:after {
	  border-top: none;
	}
	 
	  .el-tree-node {
	    position: relative;
	    padding-left: 16px;
	  }
	 
	  .el-tree-node__children {
	    padding-left: 16px;
	  }
	 
	  .el-tree-node :last-child:before {
	    height: 38px;
	  }
	 
	  .el-tree > .el-tree-node:before {
	    border-left: none;
	  }
	 
	  .el-tree > .el-tree-node:after {
	    border-top: none;
	  }
	 
	  .el-tree-node:before {
	    content: "";
	    left: -4px;
	    position: absolute;
	    right: auto;
	    border-width: 1px;
	  }
	 
	  .el-tree-node:after {
	    content: "";
	    left: -4px;
	    position: absolute;
	    right: auto;
	    border-width: 1px;
	  }
	 
	  .el-tree-node:before {
	    border-left: 1px solid #999;//指示线的样式和颜色粗细
	    bottom: 0px;
	    height: 100%;
	    top: -19px;
	    width: 1px;
	  }
	 
	  .el-tree-node:after {
	    border-top: 1px solid #999; //指示线的样式和颜色粗细
	    height: 20px;
	    top: 18px;
	    width: 24px;
	  }
	 
	.tree-container { //树的parent，样式自定
	  }

.el-tree-node__content{
	.el-radio{
		position: relative;
		z-index: 99;
	}
	padding-left: 0 !important;
}

.color-tree{
	.el-tree > .el-tree-node{
		margin-bottom: 12px;
		& > .el-tree-node__content{
			background: $color !important;;
			// background: #356d9d !important;
			border-radius: 5px;
			.el-radio{
				color: #fff;
				.col-red{
					background: #fff;
					padding: 0 2px;
				}
				.el-radio__inner::after{
					background: transparent;
				}
			}
			.el-radio__input.is-checked+.el-radio__label{
				color: #fff;
			}
			
			.el-radio__input.is-checked .el-radio__inner{
				// background:rgb(103, 194, 58);
				// border-color:rgb(103, 194, 58);
			}
		}
		.el-tree-node__children{
			background: #f5f5f5 !important;
		}
	}
	
}

.course-popup{
	.el-dialog__body{
		padding: 5px 20px 0;
	}
	
}

.add-course{
	.custom-tree-node{
		width: 100%;
		text-align: left;
		.el-radio__input{
			opacity: 0;
			display: none;
		}
		.el-radio{
			height: 36px;
			line-height: 36px;
		}
	}
	.el-tree-node__expand-icon.is-leaf{
		width: 2px;
	}
}


.cer-ucard{
	margin-bottom: 20px;
	.el-form-item{
		margin-bottom: 10px;
	}
	.btn-upload{
		width: 80px;
		height: 80px;
	}
	.avatar-uploader .el-upload{
		line-height: 0;
	}
	
	.el-form--label-top .el-form-item__label{
		padding: 0;
	}
}

.dialog-popup{
	.btn-upload{
		width: 80px;
		height: 80px;
	}
	.avatar-uploader .el-upload{
		line-height: 0;
	}
}
.certable{
	width: 99%;
	&.active{
		
	}
	.el-table .cell{
		overflow: visible;
	}
	// .el-table .el-table__cell{
	// 	padding: 0;
	// }
	
	.el-table th.el-table__cell.is-leaf{
		background: #f9faff;
	}
}

.tree-item{
	width: 100%;
	background: #fafbfc;
	border-radius: 10px;
	margin-bottom: 10px;
	.tree-link{
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 40px;
		line-height: 40px;
		padding: 0 15px;
		font-size: 15px;
		&.active{
			background: #1492ff;
			color: #fff;
			border-radius: 10px;
			.tit{
				color: #fff;
			}
			> .right > .el-icon-arrow-down{
				transform: rotate(180deg);
			}
		}
	}
	.tit{
		&.color{
			color: $color;
		}
	}
	.sub-wrap{
		display: block;
		padding: 0 15px;
	}
	.tree-link-sub{
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 40px;
		line-height: 40px;
		padding: 0 5px;
		
		font-size: 15px;
	}
	.el-icon-arrow-down{
		font-size: 18px;
		transition: all .3s;
	}
}


.coursehot-popup{
	.el-dialog__body{
		padding: 10px 15px 20px;
	}
	.qtable.md .el-table td.el-table__cell{
		font-size: 13px;
	}
}


.inp-warp {
		margin-top: 10px;
		padding: 12px;
		background: #f5f5f5;
		display: block;
		text-align: left;
		border-radius: 5px;

		.label {
			font-size: 15px;
			margin-bottom: 6px;
			display: block;
			font-weight: bold;
		}

		.cont {
			width: 100%;
			margin-bottom: 5px;
			padding: 0;
		}

		.value {
			font-size: 13px;
		}
	}
	
	
	.car-wrap{
	   padding: 30rpx;
	   .link{
		   text-align: center;
		   margin-top: 20px;
	   }
	   .color{
		   color: $color;
		   font-size: 16px;
	   }
	   .icon{
		   width: 106px;
		   height: 100px;
		   display: block;
		   margin: 0 auto;
	   }
	   .text{
		   text-align: center;
		   font-size: 18px;
		   line-height: 1.6;
		   margin-top:20px;
		   color: #333;
	   }
	}
	
	.main-bg{
		background: url('~@/static/bg_main.png') no-repeat left top;
		background-size: 1920px auto;
		
	}
	
	.main-bg2{
		background: url('~@/static/bg_main2.png') no-repeat left top;
		background-size: 1920px auto;
	}
	.main-bg3{
		background: #F7FBFF url('~@/static/bg_main3.png') no-repeat center top;
		background-size: 1920px auto;
	}
	.main-bg4{
		background: #F7FBFF url('~@/static/bg_main4.png') no-repeat center top;
		background-size: 1920px auto;
	}
	.main-bg5{
		background: #F7FBFF url('~@/static/bg_main5.png') no-repeat center top;
		background-size: 1920px auto;
	}
	
	.color-main{
		color: $color;
	}
	.breadcrumb{
		.color-main{
			font-weight: bold;
		}
	}
	
	.el-pagination.is-background .el-pager li:not(.disabled).active{
		background: #1B3194 !important;
	}
	.el-pager li:hover{
		color: #1B3194 !important;
	}
	
	.tables{
		.el-table__header-wrapper{
			.has-gutter{
				border-radius: 4px 4px 0px 0px;
				.is-leaf{
					background: #F0F2F5;
					border-bottom: 0;
				}
				.cell{
					color: #909399;
				}
			}
		}
	}
	
	
	.form-chagent-tel{
		display: flex;
		.el-input__inner{
			background: #F2F9FF;
			border: 0;
		}
	}
	
	
	.course-wrap{
		min-height: 260px;
		.course-list{
			display: flex;
			flex-wrap: wrap;
			margin: 0 -10px;
		}
		li{
			width: 285px;
			margin: 0 10px 24px;
		}
		.item{
			display: block;
			background: #FFFFFF;
			border-radius: 4px;
			overflow: hidden;
			transition: all .3s;
			&:hover{
				transform: translate(0,-5px);
				box-shadow: 0px 2px 16px 0px rgba(0,0,0,0.2);
			}
		}
		.cover{
			width: 100%;
			height: 160px;
			display: block;
		}
		.info{
			height: 64px;
			padding: 12px 16px;
			.title{
				font-size: 14px;
				color: #666;
				line-height: 1.3;
			}
		}
	}
	
	.dialog-wrap .icon-state, .dialog-wrap2 .icon-state{
		display: none;
	}
	
	.popup-appli{
		.title{
			color: $color;
		}
		.cover{
			width: 200px;
			height: 200px;
		}
	}
</style>